import { render, staticRenderFns } from "./BatchTransferTable.vue?vue&type=template&id=0806d6df&"
import script from "./BatchTransferTable.vue?vue&type=script&lang=js&"
export * from "./BatchTransferTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchTransferTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports